module.exports = __webpack_public_path__ + "media/images/icon-3-6c79b427741bb89f930aada7b32e57d7.svg";